<template>
    <div class="layout-column-warpper">
        <Item v-for="(item, index) in layoutConfig.children" :config="item" :key="index" :class="{'selected-component':item===selectedComponent}">
          <slot :name="index">
            <h3>{{index+''}}</h3>
          </slot>
        </Item>
    </div>
</template>
<style lang="less">
  .layout-column-warpper{
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .selected-component {
        background: #80800075;
    }
  }
    
</style>
<script>
import Item from "./layout-column-item";
export default {
    props: [
    'isEditing',
    'layoutConfig',
    'cellStep',
    'selectedComponent'
  ],
  components:{
    Item
  },
  methods: {
    getSlotPosition(dropEvent, defaultSize){
      let height, width;
      if(defaultSize&&defaultSize.height){
        height = {
          unit:'px', value:defaultSize.height
        }
      }else{
        height = {
          unit:'%', value:100
        }
      }
      if(defaultSize&&defaultSize.width){
        width = {
          unit:'px', value:defaultSize.width
        }
      }else{
        width = {
          unit:'%', value:100
        }
      }
      return {
        height,width
      };
    }
  },
}
</script>